import { render, staticRenderFns } from "./VaMessageList.vue?vue&type=template&id=04fe9fa1&"
import script from "./VaMessageList.vue?vue&type=script&lang=js&"
export * from "./VaMessageList.vue?vue&type=script&lang=js&"
import style0 from "./VaMessageList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports